// These colors were all pulled out of this page https://petsmart.canto.com/s/V6IQM?viewIndex=0
export const ColorPalette = {
    // ***ALL COLORS BELOW ARE FOR STANDARD COLOR SWATCHES***
    // Basic Colors
    Black: '#000000',
    White: '#FFFFFF',
    Gray: '#D3D3D3',
    'Light Gray': '#c4c4c4',
    Grey: '#D0D0D0',
    Silver: '#808080',

    // Browns
    Brown: '#8A4512',
    Beige: '#CC9966',
    Tan: '#D0A8A7',
    'Light Brown': '#AC744C',
    'Dark Brown': '#663300',

    // Greens
    Green: '#2FB534',
    'Lime Green': '#bff607',
    Olive: '#006634',
    'Light Green': '#99CC99',
    'Dark Green': '#006634',

    // Blues
    Blue: '#038DFF',
    Teal: '#69c8c5',
    'Light Blue': '#0077EE',
    'Dark Blue': '#0C20CE',
    'Royal Blue': '#0E27C2',

    // Reds and Pinks
    Red: '#DD2834',
    'Dark Red': '#990000',
    'Light Red': '#ff6666',
    Pink: '#DA9AD3',
    'Dark Pink': '#990066',
    'Light Pink': '#ff92bb',

    // Oranges and Yellows
    Orange: '#FD9D02',
    'Dark Orange': '#DA6904',
    'Light Orange': '#f5ceb3',
    Yellow: '#E5E401',
    'Dark Yellow': '#d1d200',
    Gold: '#D0B876',
    Cream: '#FEFFCD',

    // Purples
    Purple: '#9916FF',
    'Dark Purple': '#330066',
    'Light Purple': '#CA97FF',

    // ALL COLORS BELOW ARE OLDER BUT MAY BE USED FOR getColorName so I have kept them if they are neded for personalization needs.

    // Basic Colors
    Ombre: '#2A7074',
    Concrete: '#757575',

    // Browns
    Chocolate: '#D0A8A6',

    // Greens
    'Hunter Green': '#215E21',
    'Neon Green': '#0FFF50',
    Sage: '#00FF01',
    Mint: '#B9DFD4',

    // Blues
    Maroon: '#990100',
    'Blue Lagoon': '#0077A7',
    'Sapphire Blue': '#0E02D0',
    Navy: '#0077A7',
    'Spa Blue': '#6BB1CC',
    Aqua: '#CFE0FA',

    // Reds and Pinks
    Wine: '#990201',
    Cranberry: '#990001',
    'Pink Flamingo': '#FF66B2',
    'Neon Pink': '#FF1493',
    'Bright Pink': '#FF69B4',
    'Rose Gold': '#EF2B8D',
    Coral: '#F38CB2',
    Raspberry: '#F1009A',

    // Purples
    Orchid: '#DA0ADA',

    // Special Patterns and Textures
    Houndstooth: '#000010',
    Camo: '#8A4044',
    Camouflage: '#8A4000',
    Linen: '#AAAAAA',
} as const;
